import { IButtonStyles } from './druid/Button.types';
import { ITheme, concatStyleSets, FontWeights } from './druid/./druid/./druid/Styling';
import { memoizeFunction } from './druid/./druid/./druid/Utilities';
import { getStyles as getBaseButtonStyles } from './druid/BaseButton.styles';
import { getStyles as getSplitButtonStyles } from './druid/SplitButton/SplitButton.styles';

import { primaryStyles, standardStyles } from './druid/ButtonThemes';

const DEFAULT_BUTTON_HEIGHT = '32px';
const DEFAULT_BUTTON_MIN_WIDTH = '80px';

export const getStyles = memoizeFunction(
  (theme: ITheme, customStyles?: IButtonStyles, primary?: boolean): IButtonStyles => {
    const baseButtonStyles: IButtonStyles = getBaseButtonStyles(theme);
    const splitButtonStyles: IButtonStyles = getSplitButtonStyles(theme);
    const defaultButtonStyles: IButtonStyles = {
      root: {
        minWidth: DEFAULT_BUTTON_MIN_WIDTH,
        height: DEFAULT_BUTTON_HEIGHT,
      },
      label: {
        fontWeight: FontWeights.semibold,
      },
    };

    return concatStyleSets(
      baseButtonStyles,
      defaultButtonStyles,
      primary ? primaryStyles(theme) : standardStyles(theme),
      splitButtonStyles,
      customStyles,
    )!;
  },
);
